import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Paper, Button} from "@material-ui/core";
import {withStyles} from '@material-ui/core/styles';
import {insert, set, del} from 'object-path-immutable';
import _ from 'lodash';
import {JsonScreenProvider} from '../../ContextComponents/JsonScreenContext'
import {withSnackbar} from "notistack";
import {connect} from "react-redux";
import Screen from "./Screen";
import {
    generatingDefaultFields, defaultScreen, getSafe,
    ReportMenu
} from './Utils'
import Loading from "../../Utils/Loading/Loading";
import request from "../../Services/API/Requests";
import findByString from "../../Utils/Form/FormDynamic/Utils/getValueByString";
import asyncForEach from "../../Utils/Form/FormDynamic/Utils/asyncForEach";
import {setClearProps} from "../../app/app.slice";
import {
    clearGlobalValues, setFieldValue,
    setGlobalValues,
    setInParam,
    setIsChanged,
    setLoading,
    setQueryParams,
    setScreen,
    setScreenName, setVariable, getNewScreen
} from "./jsonScreen.slice";
import IntervalTimer from "./Screen/OtherComponents/IntervalTimer";
import {uid} from "react-uid";
import {cacheScreens, getScreenFromCache, queryParamsToJson, scrollToElement} from "./Utils/lib";
import ReactGA from "react-ga4";
import config from 'config'
import TagManager from "react-gtm-module";
import ShortcutListener from "./Screen/OtherComponents/ShortcutListener";
import ContextMenu from "./Screen/ScreenComponents/ContextMenu";
import defaultScreenNew from "./Utils/defaultScreenNew";

const styles = (theme) => ({
    dialogTitle: {
        padding: '16px 24px 16px'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(),
        top: 4,
        color: theme.palette.grey[500],
    },
    dialogRoot: {
        padding: '0px 0px 0px',
        '&:first-child': {
            paddingTop: 4
        }
    },
    rootPaper: {
        //  margin: '10px auto',
        position: 'relative'
    },
    reportContainer: {display: 'flex', flexDirection: 'row', justifyContent: 'center', height: '100%'},
    screenContainer: {height: '100%', display: 'flex'}
});

const mapStateToProps = state => {
    return {
        appState: state.app,
        jsonScreen: state.jsonScreen,
        popup: state.popup
    };
}


class JsonScreen extends Component {
    constructor(props) {
        super(props);
        this.screenRef = React.createRef();
        this.submitFnRef = React.createRef();
        this.onBeforeUnload = (ev) => {
            ev.returnValue = "Anything you wanna put here!";
            return true
        };
        this.state = {
            errorComponent: false,
            beforeUnloadListener: false,
            //store lists which need to refresh
            refreshData: {},
            //store filter which need to refresh
            setFilter: {},
            stringFilter: {},
            errors: [],
            screen: {
                entity: '', otherComponents: [], children: []
            },
            prevListState: {
                //format is
                // ['listName']: {sort: [],
                //                 searchValue: {},
                //                 advancedFilter: [],
                //                 sort: []
                //                 page: 0,
                //                 focusedRow: 0
                //                 }
            }
        };
    }

    async componentDidMount() {
        const {match: {params: {name: screenName}}} = this.props;
        this.mountPropsManager(screenName);
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        const {match: {params: {name: screenName}}} = this.props;
        const {match: {params: {name: prevScreenName}}} = prevProps;
        if (screenName !== prevScreenName) {

            if (this.state.beforeUnloadListener) {
                window.removeEventListener("beforeunload", this.onBeforeUnload);
            }

            this.updatePropsManager(screenName);
            this.setState({checkedData: {}})
        }
    }

    componentWillUnmount() {

        if (this.state.beforeUnloadListener) {
            window.removeEventListener("beforeunload", this.onBeforeUnload);
        }
        this.props.dispatch(clearGlobalValues({
            screenId: this.state.screenId,
            isPopup: this.props.isPopUp || this.props.dropdownMode
        }))
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            nextProps.appState.drawerWidth === this.props.appState.drawerWidth
        )
    }

    componentDidCatch(error, errorInfo) {
        if (error) {
            this.setState({errorComponent: true});
            console.log(errorInfo)
        }
    }

    async mountPropsManager(screenName) {
        const {popupState, location: {state: {inParam, prevListState, entity, idType} = {}}} = this.props;
        await this.screenChanger(screenName, inParam, entity, popupState, prevListState, idType);
    };

    async updatePropsManager(screenName) {
        const {location: {state: {inParam, prevListState, entity, idType} = {}}} = this.props;
        await this.screenChanger(screenName, inParam, entity, {}, prevListState, idType);
    };

    async screenChanger(screenName, inParam = {}, entity, popupState, prevListState, idType) {
        const {
            match: {params: {id, screenInfo}},
            location: {state: {pathStack} = {}},
            dispatch, appState, dropdownMode
        } = this.props;
        const queryParams = queryParamsToJson(window.location.href);

        //send to google analytics current page
        if (config && config.ga_key) {
            // ReactGA.send({hitType: 'pageview', page: window.location.pathname, title: screenName})
        }

        if (config && config.gtm_key) {
            // window.dataLayer = window.dataLayer || [];
            // window.dataLayer.push({
            //     event: "pageview",
            //     pageTitle: screenName,
            // });
            // console.log(window.dataLayer)
            // TagManager.dataLayer({
            //     pageview: {
            //         page: {url: window.location.pathname, pageTitle: screenName}
            //     }
            // })
        }

        dispatch(setQueryParams({screenName, screenInfo, queryParams}))
        !dropdownMode && dispatch(setScreenName(screenName));
        dispatch(clearGlobalValues({
            screenId: this.state.screenId || screenName,
            isPopup: this.props.isPopUp || dropdownMode
        }));
        const newInParam = !Boolean(_.isEmpty(inParam[screenName])) ? inParam[screenName] : {id, ...inParam[screenName] || {}};
        if (_.isEmpty(popupState)) {
            dispatch(setInParam({screenName, data: newInParam}))
            this.setState({
                //globalValues: newGlobalValues,
                screenName,
                screenId: screenName,
                screen: {children: []},
                prevListState: prevListState ? prevListState : appState.clearProps ? {} : {},
                pathStack: pathStack
            }, async () => {
                await this.getNewScreen(screenName, idType);
            });
            appState.clearProps && dispatch(setClearProps(false))
        } else {
            // let newGlobalValues = set({session: globalValues.session}, `inParam`, popupState.inParam);
            dispatch(setInParam({screenName, data: popupState.inParam}))
            this.setState(state => ({
                checkedData: popupState.inParam.checkedData,
                screenName: popupState.screenName,
                screenId: popupState.screenName,
                prevListState: prevListState ? prevListState : state.prevListState,
            }), async () => {
                await this.getNewScreen(screenName, idType)
            });
        }
    }

    //read screen record
    async getNewScreen(screenName, idType) {
        const {enqueueSnackbar, jsonScreen: {globalValues}, appState, dispatch, location} = this.props;
        const screenInParam = globalValues.inParam[screenName] || {};
        const {id, _entity} = screenInParam;
        this.setState({loadingScreen: true});
        try {
            //check for available screen
            let newScreen = {};
            newScreen = await dispatch(getNewScreen({id: screenName}))
            if (screenName) {
                const cachedScreen = null;//getScreenFromCache(appState.appEnv, appState.application, screenName)
                if (cachedScreen) {
                    newScreen = cachedScreen;
                } else {


                    newScreen = await request({
                        url: 'screen/read',
                        method: 'POST',
                        data: {id: screenName}
                    })
                }
            }
            await this.checkForScreenEvents(newScreen);

            //set to storage screens
            try {
                // cacheScreens(appState.appEnv, appState.application, newScreen)
            } catch (e) {
                console.log('set to cache err', e)
                console.log(e)
            }

            this.setState({
                loadingScreen: false,
                errors: []
            }, () => {
                if (location.hash) {
                    scrollToElement(location.hash.substr(1))
                }
            });

        } catch (e) {
            if (e.status === 404) {
                //generate screen by schema
                this.setState({loadingScreen: false});
                dispatch(setLoading(true))
                const schema = await this.readSchema(screenName);
                if (schema) {
                    const responseValues = await this.readRecord(schema.id, idType, globalValues.inParam[screenName]);
                    const emptyScreen = {
                        entity: schema.id,
                        children: [],
                        errors: [],
                        styles: [
                            {
                                width: "100%",
                                padding: "0px",
                                margin: "0px auto",
                                height: "100%"
                            }
                        ]
                    };
                    dispatch(setGlobalValues({screenName, data: {[schema.id]: responseValues || {}}}))
                    this.setState({screen: emptyScreen}, () => {
                        this.generateDefaultScreen(schema, globalValues.inParam[screenName], responseValues);
                    });
                    return;
                }
                dispatch(setLoading(false))
                enqueueSnackbar('This screen does not exists!', {variant: 'error'});
            }
            this.setState({loadingScreen: false});
        }
    };

    //read entitySchema
    async readSchema(schemaId) {
        const {dispatch} = this.props;
        try {
            return await request({
                url: "schema/read",
                method: "POST",
                data: {id: schemaId}
            })
        } catch (e) {
            dispatch(setLoading(false))
        }

    }

    //read entity record
    async readRecord(entity, idType, inParam) {
        const {match: {params: {id}}, dispatch} = this.props;
        const {id: inParamId} = inParam;
        const {enqueueSnackbar} = this.props;
        const recordId = id ? idType === 'object' ? JSON.parse(id) : id : inParamId ? inParamId : null;
        dispatch(setLoading(true))
        if (recordId) {
            try {
                const response = await request({
                    url: `${entity}/read`,
                    method: 'POST',
                    data: {id: recordId}
                });
                dispatch(setLoading(false))
                return response;
            } catch (err) {
                if (err.data !== undefined) {
                    let errors = getSafe(() => err.data.status.message, []);
                    errors.map(e => {
                        return enqueueSnackbar(e.text, {variant: e.type});
                    });
                } else {
                    enqueueSnackbar('Read record error', {variant: 'error'});
                }
                dispatch(setLoading(false))
            }
        }
        dispatch(setLoading(false))
    }

    //screen events and actions
    async checkForScreenEvents(screen) {
        const {events} = screen;
        const {screenId} = this.state;
        if (events) {
            await asyncForEach(events, async (event) => {
                if (event.event === 'onOpen') {
                    this.props.doActions(event.actions, {}, null, screenId)
                }
                if (event.event === 'onClose') {
                    let isConfirmClose = event.actions.find(action => action.type === "confirmCloseScreen")

                    if (isConfirmClose) {
                        window.addEventListener("beforeunload", this.onBeforeUnload);
                        this.setState({beforeUnloadListener: true})
                    }

                }
            });
        }
    };

    //screen generator
    generateDefaultScreen = (entity, inParam, responseValues) => {
        const {match: {params: {id, name}}, dispatch} = this.props;
        const {id: inParamId, previewMode} = inParam;
        const recordId = id ? id : inParamId ? inParamId : null;
        const {screen} = this.state;
        const isPreview = previewMode ? previewMode !== 'false' : false;
        const record = isPreview ? responseValues : false;
        let schema = [];
        let label = entity.name//entity.name.charAt(0).toUpperCase() + entity.name.slice(1);
        generatingDefaultFields(
            entity.properties,
            schema,
            '',
            0,
            entity.id,
            true,
            entity.properties,
            false,
            record
        );
        const newScreen = defaultScreenNew({schema, label, recordId, entityName: entity.id, isPreview});
        let newScreenFields = set(screen, 'children', newScreen);
        dispatch(setScreen({[name]: newScreenFields}))
        this.setState({screen: newScreenFields});
    };


    onSubmitForm = async (event) => {
        const {jsonScreen} = this.props;
        event.preventDefault();
        if (!jsonScreen.form.isValid) {
            return
        }
        if (this.submitFnRef.current) {
            await this.submitFnRef.current()
        }
        this.submitFnRef.current = null;
    };

    exitFromErrorComponent = () => {
        this.props.history.goBack();
        this.setState({errorComponent: false})
    };

//list actions
    collectCheckedData = (checked, listName) => {
        const {screenId} = this.state;
        const {jsonScreen: {globalValues}, dispatch} = this.props;
        let newGlobalValues = set(globalValues.param[screenId], `${listName}`, checked);
        dispatch(setGlobalValues({screenName: screenId, data: newGlobalValues}))
    };
//handlers for fields
    removeFieldValue = (path, trackChange) => {
        const {screenId} = this.state;
        const {jsonScreen: {globalValues}, dispatch} = this.props;
        let newValues = del(globalValues, path);
        if (trackChange) {
            newValues = set(newValues, `${path}Changed`, true)
        }
        dispatch(setGlobalValues({screenName: screenId, data: newValues}))
        dispatch(setIsChanged(true))
    }

//array actions
    addGroup = (path, index) => {
        const {screenId} = this.state;
        const {jsonScreen: {globalValues}, dispatch} = this.props;
        console.log(path)
        const findValue = findByString(globalValues.param[screenId], path);
        const newValues = insert(findValue ? findValue : [{}], '', {}, index);

        //set new group
        dispatch(setFieldValue({
            value: newValues,
            path: `param.${screenId}.${path}`,
            trackChange: false
        }))
        dispatch(setIsChanged(true))
    };
    removeGroup = (path) => {
        const {screenId} = this.state;
        const {jsonScreen: {globalValues}, dispatch} = this.props;
        const splitedPath = path.split('.');
        const index = splitedPath.pop();
        const newPath = splitedPath.join('.');
        const findValue = findByString(globalValues.param[screenId], newPath);
        const newValues = del(findValue, index);
        //remove group
        dispatch(setFieldValue({
            value: newValues,
            path: `param.${screenId}.${newPath}`,
            trackChange: false
        }))
        dispatch(setIsChanged(true))
    };
    insertValue = (path, index, values) => {
        const {screenId} = this.state;
        const {jsonScreen: {globalValues}, dispatch} = this.props;
        const newGlobalValues = insert(globalValues, path, values, index);
        dispatch(setGlobalValues({screenName: screenId, data: newGlobalValues}))
        dispatch(setIsChanged(true))
    };


//infinity fields actions
    addNested = (path, isArray) => {
        const {screenId} = this.state;
        const {jsonScreen: {globalValues}, dispatch} = this.props;
        let newValues = set(globalValues.param[screenId], path, isArray ? [{}] : {});
        console.log(path)
        //set values
        dispatch(setGlobalValues({screenName: screenId, data: newValues}))
        dispatch(setIsChanged(true))
    };
    removeNested = (path) => {
        const {screenId} = this.state;
        const {jsonScreen: {globalValues}, dispatch} = this.props;
        let newGlobalValues = del(globalValues.param[screenId], path);
        console.log(path)
        dispatch(setGlobalValues({screenName: screenId, data: newGlobalValues}))
        dispatch(setIsChanged(true))
    };

    render() {

        const {
            errors,
            loadingScreen, prevListState,
            errorComponent, pathStack
        } = this.state;

        const {
            classes,
            history,
            location,
            dropdownMode,
            countColumns,
            currentFieldValue,
            pathToField,
            setFieldValue,
            valuesDropdown,
            doActions,
            record,
            setFreeSolo,
            currentOuterEntity,
            keyPressed,
            direction,
            dropdownProps,
            footerSource,
            jsonScreen: {globalValues, loading, screen: screenSources}
        } = this.props;
        const screen = screenSources[this.state.screenId] || {};

        const styles = screen.styles ? screen.styles[0] : {};

        return (
            !errorComponent ? (
                <JsonScreenProvider value={{
                    screen: screen,
                    footerSource,
                    screenName: this.state.screenId,
                    submitFnRef: this.submitFnRef,
                    //incoming props from field (dropdown)
                    countColumns,
                    currentFieldValue,
                    pathToField,
                    record,
                    setFreeSolo,
                    currentOuterEntity,
                    dropdownMode,
                    setFieldValue,
                    valuesDropdown,
                    keyPressed,
                    direction,

                    loadingData: loading,
                    prevListState,
                    pathStack,
                    history: history,
                    globalValues: {_preScript: screen.script, ...globalValues},

                    //fields
                    goBack: () => {
                        doActions({type: 'cancel'})
                    },
                    fieldErrors: errors,
                    setValue: (value, path, trackChange) => this.props.onChangeFields(value, `param.${this.state.screenId}.${path}`, trackChange),
                    insertValue: this.insertValue,
                    addGroup: this.addGroup,
                    addNested: this.addNested,
                    removeGroup: this.removeGroup,
                    removeNested: this.removeNested,

                    doActions: (action, context, event) => doActions(action, {
                        ...context,
                        returnValueFunction: this.props.returnValue
                    }, event, this.state.screenId),
                    collectCheckedData: this.collectCheckedData,

                    location: location,
                    screenRef: this.screenRef,
                    cameraRef: this.props.cameraRef,
                    dropdownProps
                }}>
                    {loadingScreen && <Loading/>}

                    {!loadingScreen && (
                        <div
                            className={classes.screenContainer}
                            style={{
                                alignItems: styles.alignItems,
                                justifyContent: styles.justifyContent,
                            }}
                        >
                            <Paper id={"rootPaper"}
                                   style={{
                                       width: styles.width,
                                       height: styles.height || '100%',
                                       minHeight: styles.minHeight,
                                       padding: styles.padding,
                                       margin: styles.margin,
                                       boxShadow: dropdownMode ? 'unset' : styles.boxShadow,
                                       background: dropdownMode ? 'transparent' : styles.background,
                                       overflow: 'auto',
                                   }}
                                   className={classes.rootPaper}>
                                <form style={{height: '100%'}}
                                      id={this.state.screenId + '_screenForm'}
                                      name={this.state.screenId}
                                      onSubmit={this.onSubmitForm}
                                >
                                    {loading && <Loading/>}
                                    <Screen/>
                                </form>
                            </Paper>
                            {
                                screen.otherComponents ? (
                                    screen.otherComponents.map((component,i) => {
                                        if (component.type === 'interval') {
                                            return (
                                                <IntervalTimer
                                                    key={uid(i)}
                                                    component={component}
                                                    doActions={doActions}

                                                />
                                            )
                                        }
                                        if (component.type === 'shortcut') {
                                            return (
                                                <ShortcutListener
                                                    key={uid(i)}
                                                    component={component}
                                                    doActions={doActions}
                                                    target={document.getElementById(this.state.screenId + '_screenForm')}
                                                />
                                            )
                                        }
                                        if (component.type === 'context') {
                                            return <ContextMenu
                                                key={uid(i)}
                                                doActions={doActions}
                                                component={component}
                                                screenName={this.state.screenId}
                                            />
                                        }
                                        return <React.Fragment key={i}></React.Fragment>
                                    })
                                ) : <></>
                            }
                            {
                                screen.type === 'reportContainer' && (
                                    <ReportMenu/>
                                )
                            }
                        </div>)
                    }
                </JsonScreenProvider>
            ) : (<p style={{textAlign: 'center'}}>
                Something wrong with screen component <br/>
                <Button variant={"outlined"} onClick={this.exitFromErrorComponent}>Go Back</Button></p>)

        );
    }
}


export default connect(mapStateToProps, null)(withSnackbar(withStyles(styles)(JsonScreen)));

JsonScreen.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            name: PropTypes.string //id of screen
        })
    }).isRequired,
    location: PropTypes.shape({
        state: PropTypes.shape({
            inParam: PropTypes.object,
            prevListState: PropTypes.object,
            entity: PropTypes.string,
            idType: PropTypes.string
        })
    }).isRequired,
    dropdownMode: PropTypes.bool,
    footerSource: PropTypes.object,
    /*props from dropdown*/
    countColumns: PropTypes.func,
    dropdownProps: PropTypes.object,
    keyPressed: PropTypes.string,
    direction: PropTypes.string,
    currentFieldValue: PropTypes.any,
    pathToField: PropTypes.string,
    setFreeSolo: PropTypes.func,
    searchFieldUpdate: PropTypes.func,
    setFieldUpdateFalse: PropTypes.func,
    setFieldValue: PropTypes.func,
    record: PropTypes.object,
    valuesDropdown: PropTypes.object,
    currentOuterEntity: PropTypes.string,
    doActions: PropTypes.func,
};
JsonScreen.defaultProps = {
    doActions: () => {
    }
}